var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Flex from "@irati/ui/src/Flex";
import { Hr } from "@irati/ui/src/Layout";
import Icon from "@irati/ui/src/Icon";
import { Label3 } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import IconWrapper from "../IconWrapper";
import { AdminCard, MarginLeft, FlexGrowH4, FlexGrowPara, StyledLink } from "./styled";
var SmallAdminCard = /** @class */ (function (_super) {
    __extends(SmallAdminCard, _super);
    function SmallAdminCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SmallAdminCard.prototype.render = function () {
        var _a = this.props, children = _a.children, headingTextKey = _a.headingTextKey, descriptionTextKey = _a.descriptionTextKey, iconType = _a.iconType, linkTo = _a.linkTo, iconColor = _a.iconColor, tracking = _a.tracking;
        return (React.createElement(AdminCard, null,
            React.createElement(StyledLink, { to: linkTo, onClick: tracking, plain: true },
                React.createElement(Flex, { margin: "0 0 20px", justifyContent: "space-between", alignItems: "center" },
                    React.createElement(IconWrapper, { color: iconColor },
                        React.createElement(Icon, { size: "25px", icon: iconType })),
                    React.createElement(FlexGrowH4, null,
                        React.createElement(FormattedMessage, { id: headingTextKey })),
                    React.createElement(MarginLeft, null,
                        React.createElement(Icon, { icon: "rightArrow" })))),
            React.createElement(Flex, { direction: "column", height: "100%" },
                React.createElement(FlexGrowPara, null,
                    React.createElement(FormattedMessage, { id: descriptionTextKey })),
                children && (React.createElement(React.Fragment, null,
                    React.createElement(Hr, { tiny: true }),
                    React.createElement(Label3, { small: true, uppercase: true },
                        React.createElement(FormattedMessage, { id: "admin.dashboard.smallCard.quickActions" })),
                    React.createElement(Flex, null, children))))));
    };
    return SmallAdminCard;
}(PureComponent));
export default SmallAdminCard;
